<template>
    <!--    登录组件-弹窗 -->
    <div class="loginView">
             <div class="loginBox">
                 <!-- 头部标题和账号类型菜单 -->
                 <div class="topTitleBox">
                     <div class="titleBox">
                          <h2 class="bigTitle">{{isonlyenterprise?'企业用户登录':'用户登录'}}</h2>
                          <div class="del" @click="delAction">
                            <i class="el-icon-close"></i>
                          </div>
                     </div>
                     <!-- 菜单导航 -->
                    <el-tabs v-model='active' @tab-click='handleClick' v-if="!isonlyenterprise">
                        <el-tab-pane label='企业用户' name='first'></el-tab-pane>
                        <el-tab-pane label='中介机构' name='three'></el-tab-pane>
                        <el-tab-pane label='管理员' name='second'></el-tab-pane>
                    </el-tabs>
                 </div>
                 <!-- 输入框表单 -->
                <div class="form">
                    <el-form label-width="80px" label-position='left'>
                        <el-form-item label='用户名'>
                            <el-input v-focus placeholder='输入手机号码' @blur="getParkByPhone" v-model.trim='username'></el-input>
                        </el-form-item>
                        <el-form-item label='密码'>
                            <el-input placeholder='输入密码' v-model.trim='password' type="password"></el-input>
                        </el-form-item>

                        <el-form-item label='验证码'  v-if="showCodeFlag">
                            <div class="imageCodeBox">
                                <el-input v-focus placeholder='输入验证码'  class="imageCode" v-model.trim='imageCode'></el-input>
                                <img :src="imgCodeUrl" alt="验证码" v-if="showImageCode" @click="refreshImage">
                            </div>
                        </el-form-item> 
                    </el-form>
                    <el-button type='primary' style="width:100%; margin-top: 10px;" @click='doLogin'>登录</el-button>
                    <!-- 底部-注册-忘记密码 -->
                    <div class="bottom">
                        <div v-if='active==="first" | active==="three"'>还没{{active==="first"?'企业用户':'中介机构'}}账号？<a @click='goRegist'>立即注册</a></div>
                        <div v-else></div><!-- 占位-方便样式排版 -->
                         <!-- 展示隐藏-忘记密码 仅企业和中介机构显示忘记密码按钮-->
                        <div class="forgotPwd" @click='goForgotPwd' v-if='active==="first" | active==="three"'>忘记密码</div>
                        <!-- 占位-防止页面抖动 -->
                        <div class="forgotPwd" v-else>&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>

</template>

<script>
/**
 * userType:
 * 14 中介机构
 * 8 客户经理 0 超级管理员也属于客户经理类别
 * 9 企业
 */
    export default {
        name: "lp-login",
       data() {
        return {
            active: 'first',
            tabIndex: 0,
            username: '',
            password: '',
            parks: [],
            parkId: 0,
            userType: 9,
            imgCodeUrl:'',
            showImageCode:true,
            showCodeFlag:false,
            imageCode:'',
            host:process.env.baseURL
        };
    },
    mounted() {
        window.HCYMENUS = 0;
        this.imgCodeUrl=`${this.host}/captchaImage/imageCaptcha`;
    },
    directives: {
        /**
         * 浏览器自动填充账号和密码，触发聚焦事件
         */
        focus: {
            inserted: function(el) {
                el.focus();
            }
        }
    },
    watch: { 
         'username': {
            handler: function(newVal, old) {
                /**
                 * console.log(`newVal:${newVal}, old:${old}`);
                 * 企业用户、中介机构输入用户名需要获取相应的园区
                 */
                //临平新城-固定parkId是4
                // if( (this.active === "first" | this.active === "three") && newVal) {
                //     this.getPark();
                // }
            },
            immediate: true
        },
        'active': function(newVal) {
            switch(newVal) {
                case 'first':
                    this.userType = 9;
                    break;
                case 'second':
                    this.userType = 8; 
                    break;
                case 'three':
                    this.userType = 14; 
                    break;
            }
            this.showCodeFlag=false;
        }
    },
    methods: {
        //获取园区列表
        async getParkByPhone(){
            const { showCodeFlag,username }=this;
            if(!/^[0-9][0-9]\d{9}$/.test(username)){
                this.$message.error('请输入正确手机号')
                return;
            }
            if(showCodeFlag){
                this.refreshImage();
            }else{
                this.showCodeFlag=true;
                this.imgCodeUrl=`${this.host}/captchaImage/imageCaptcha?phone=${username}`;
            }
        },
        //刷新验证码
        refreshImage(){
            this.showImageCode=false;
            this.imgCodeUrl=`${this.host}/captchaImage/imageCaptcha?phone=${this.username}`;
            this.$nextTick(()=>{ this.showImageCode=true })
        },
        //菜单-切换
        handleClick(tab, event) {
            this.tabIndex = tab.index;
            this.username = '';
            this.password = '';
            if(this.parkId) this.parkId = '';
        },
        // 登录弹窗-隐藏
        delAction(){
            this.$store.commit('SET_LOGIN',false);
        },
        /*跳转*/
        // 注册
        goRegist() {
            // window.location.href=this.$store.state.backHref+'#/regist?type='+this.tabIndex+'&origin=1';
            // 隐藏登录窗口
             this.$store.commit('SET_LOGIN',false);
             // type判断账号类型 
             this.$router.push({path: '/register', query: {type: this.tabIndex}});

        },
         // 忘记密码 
        goForgotPwd() {
            // window.open(this.$store.state.backHref+'#/forgotPwd?model='+this.tabIndex)
            // 隐藏登录窗口
             this.$store.commit('SET_LOGIN',false);
            //  type判断账号类型 
            this.$router.push({path: '/forgetPassword', query: {model: this.tabIndex}});
        },
        
        /*登录*/
        async doLogin() {
            if(!this.mustFill()) return;
             const { parkId }=this.$store.state;
             const { imageCode }=this;
            const params={
                parkId:parkId,//不分账号，都是本园区
                username: this.username,
                userType: this.userType,
                password: this.password,
                imageCode,
                grantType: 'password',
                isImage:true
            }
            const res=await this.$Apis.login(params);
            const { code,msg,data }=res;
            if(code==1){ 

            //  企业状态- 满足:已入驻&未迁出&已通过审核-才能下一步操作！
            //  isSettled: true - isMoveOut: false - applyStatus:2(通过)
            if(res.data.extra.companyInfo){
                localStorage.setItem('isSettled', res.data.extra.companyInfo.isSettled || '');
                this.$store.commit('SET_ISSETTLED',res.data.extra.companyInfo.isSettled);
                localStorage.setItem('isMoveOut', res.data.extra.companyInfo.isMoveOut || '');
                localStorage.setItem('applyStatus', res.data.extra.companyInfo.applyStatus|| '');
                localStorage.setItem('companyId', res.data.extra.companyInfo.id || '');
            }
              //机构信息
            let institutionInfo=res.data.extra.institution;
            if(institutionInfo){
                localStorage.setItem('GLOBAL_USER_InstitutionId', institutionInfo.id?institutionInfo.id:'');
            }
            //其它
            localStorage.setItem('GLOBAL_USER_PHONE', res.data.user.phone);//手机号
            localStorage.setItem('X_TOKEN', res.data.access_token);
            localStorage.setItem('REFRESH_TOKEN', res.data.refresh_token);//跳转到后台的时候需要带着
            let key = ['0', '8'].indexOf(res.data.user.userType) > -1
                ? 'manage'
                : (res.data.user.userType ==9)
                    ? 'front' : 'agent';
            localStorage.setItem('HOSTKEY', key);//判断企业还是其他的身份
            this.$store.commit('SET_HOSTKEY', key);
            this.$store.commit('SET_REFRESH_TOKEN', res.data.refresh_token);
            this.$store.commit('SET_TOKEN', res.data.access_token);
            /*
            注意：因为一开始是username，不过后来只需要手机号，
            所以字段名称仍然是username，不过里面的保存的数据是phone
            */ 
           localStorage.setItem('usertype', res.data.user.userType);
            this.$store.commit('SET_USERTYPE', res.data.user.userType);
            localStorage.setItem('username', res.data.user.phone);//都改手机号
            this.$store.commit('SET_USERNAME', res.data.user.phone);

            localStorage.setItem('componyName', res.data.extra.companyInfo.companyName);//公司名
            this.$store.commit('SET_COMPONYNAME',res.data.extra.companyInfo.companyName);
            //登录弹窗隐藏
            this.$store.commit('SET_LOGIN',false);
             this.$message.success('登录成功');
            //定位首页
            // this.$router.push('/');//不需要定位首页
            
            }
           
        },
        //校验
         mustFill() {
            if(!this.username) {
                this.$message.error('请输入用户名');
                return false;
            }

            if (!/^[0-9][0-9]\d{9}$/.test(this.username)) {
                this.$message.error('请填写正确的手机号码');
                return false;
            }

            if (!this.password) {
                this.$message.error('请输入密码');
                return false;
            }   

            return true;
        },
        
    },
    computed: {
            // 是否-仅-显示企业账号的登录方式
            isonlyenterprise(){
                return this.$store.state.isonlyenterprise;
            }
    },
}
</script>


<style lang="less" scoped>
    .loginView{
        position: fixed;
        z-index: 99;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.60);
        top:0px;
        left:0px;
        display: flex;
        justify-content: center;
        align-items: center;
        // 内容
             .loginBox {
                width: 492px;
                border-radius: 4px;
                background: #fff;
                box-sizing: border-box;
                // 头部标题和账号类型按钮菜单
                .topTitleBox{
                // 头部标题
                    .titleBox{
                        width: 100%;
                        height: 56px;
                        background: rgba(0,0,0,0.05);
                        // background: #EDEDED;
                        position: relative;
                         h2 {
                            height: 56px;
                            width: 100%;
                            padding: 0;
                            margin: 0;
                            color: #333;
                            text-align: center;
                            font-family: MicrosoftYaHei-Bold;
                            line-height: 56px;
                        }
                        .del{
                            width: 56px;
                            height: 56px;
                            position: absolute;
                            right: 0;
                            bottom: 0;
                            cursor: pointer;
                            i{
                                width: 11.3px;
                                height: 11.3px;
                                color: #999;
                                position: absolute;
                                right: 18.4px;
                                bottom: 22.4px;
                            }

                        }                        
                    }
                }   
                // 表单
                .form {
                    padding: 0 48px;
                    margin-top: 30px;
                    font-size: 14px!important;
                    // 登录按钮样式
                    .el-button--primary{
                        margin-top: 24px!important;
                        background: #1582F3;
                        border-radius: 4px;
                    }
                    .bottom {
                        display: flex;
                        font-family: MicrosoftYaHei;
                        justify-content: space-between;
                        font-size: 14px;
                        margin-top: 10px;
                        color: #333;
                        margin-bottom: 34px;
                        a {
                            color:  #1890FF;
                            cursor: pointer;
                        }
                        .forgotPwd {
                            color:  #999;
                            cursor: pointer;
                        }
                    }
                }
               
            }
        .imageCodeBox{
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            .imageCode{
            width: 60%;
            }
            img{
                width:35%;
                height: 40px;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/login/index.vue